import React from 'react';

import Money from '@components/Gui/Money';

/**
 * StatementOriginalAmount
 *
 * Original amount of a converted statement line, on its own line under the converted amount
 * (same layout as StatementAmountCell in the billing and project lists)
 */
const StatementOriginalAmount = ({ amount, amounts, currency, printable }) => {
    return (
        <>
            <br />
            <Money
                small
                highlightCurrency={!printable}
                redIfNegative={!printable}
                amount={amount}
                amounts={amounts}
                currency={currency}
            />
        </>
    );
};

export default StatementOriginalAmount;
